// @flow

import React from 'react';
import { graphql } from 'gatsby';
import styled from 'styled-components';

import { WebsiteDefaultPage as BaseWebsiteDefaultPage } from 'components/Page';
import { PageType } from 'Constants';
import { OriginationFees } from 'data/global/footer/legal/numbered';
import { useImages } from 'hooks';
import { flex, Layout, maxWidthContainer, topBottomMargin, Width } from 'styles';
import { MarketsHero, ResourcesSideBar } from 'components/Content';

const METADATA = {
  title: 'Financial products to simplify finances, faster',
  description: `At Markets Direct, we’re transforming home equity by creating a fast, simple and transparent process to bring you closer to your financial goals. We'll show you how to use home equity to consolidate debt, pay for home improvement or fund your retirement. It's quick and easy. Let’s unlock the potential of your largest asset.`,
};

const PAGE_TYPE = {
  product: PageType.PRODUCT.NONE,
};

const WebsiteDefaultPage = styled(BaseWebsiteDefaultPage)`
  width: 100% !important;
`;

const Wrapper = styled.div`
  width: 100%;
  ${flex()};
  flex-direction: column;
  ${topBottomMargin([Layout.NAV_HEIGHT_MOBILE, 0], [Layout.NAV_HEIGHT_DESKTOP, 0], [Layout.NAV_HEIGHT_DESKTOP, 0])};
`;

const Content = styled.div`
  width: 100%;
  background: white;

  > div {
    padding: 40px 0;
    ${maxWidthContainer(1080)};
    ${flex()};
    flex-direction: column;

    @media (min-width: ${Width.BREAK_MD}px) {
      ${flex('flex-start', 'flex-start')};
      flex-direction: row;
    }
  }
`;

const Text = styled.div`
  white-space: pre-line;
`;

const PageContainer = ({ data }: { data: any }) => {
  const getImage = useImages(data);

  return (
    <WebsiteDefaultPage
      page={PAGE_TYPE}
      metaData={{
        ...METADATA,
        image: getImage('resources'),
      }}
      footerLegal={{
        numbered: OriginationFees,
      }}>
      <Wrapper>
        <MarketsHero
          title="RESOURCES"
          blurb="Hello? How can we help you?"
          image={{
            name: 'resources',
          }}
          images={data}
        />
        <Content>
          <div>
            <ResourcesSideBar sectionIndex={0} pageIndex={3}>
              <Text>
                {`
Triton Capital Markets Limited Limited is committed to comply with all relevant AML and funding of terrorism regulations including but not limited to the 4th anti money laundering directive which has been fully transposed into Maltese regulations via the legal notice 372 of 2017-the Prevention of Money Laundering and Funding of Terrorism Regulations and guidelines and reports issued by the FATF.

Triton Capital Markets Limited believes that compliance with Anti money laundering regulations is essential for the integrity of financial systems.

The company expects all its management and employees to comply with this policy.

The following criteria are the pillars of Triton Capital Markets Limited’s anti money laundering policy which are essential to ensure compliance with regulations and to protect our customers

`}
                <strong>Know your customer Policy</strong>
                {`
                
Triton Capital Markets Limited asks clients a number of questions during the application stage in order to understand customers and ensure that the applicant is not a victim of financial crime. Documentation is collected from clients in order to verify the information provided at the application stage. Such documents may be verified electronically during the application process.

Periodically, Triton Capital Markets Limited also requests customers provide updates to the personal information which has been provided at the application stage to ensure that the data and information about its customers is up to date.

Triton Capital Markets Limited identifies and verifies the ultimate beneficial owner that is the person that is the persons who own and control the company or on whose behalf the transaction is carried out.

`}
                <strong>Controls</strong>
                {`
                
Triton Capital Markets Limited has a number of internal controls including but not limited to the non-acceptance of cash and the non-acceptance of third party deposits and redemptions. Triton Capital Markets Limited does not accept clients from Iran and North Korea as these have been identified by the FATF as non-cooperative jurisdictions. Triton Capital Markets Limited does not accept any anonymous accounts and does not maintain any relationships with shell banks.

`}
                <strong>Training of employees</strong>
                {`
                
Triton Capital Markets Limited conducts extensive due diligence on its employees before recruitment. In addition, Triton Capital Markets Limited employees are provided with regular training in order to be aware of possible patterns and techniques in money laundering and to detect possible suspicious activity.

`}
                <strong>Reporting Suspicious Activity</strong>
                {`
                
In line with the relevant regulations any suspicious activity of money laundering and funding of terrorism is reported to the relevant authorities.

`}
                <strong>Record Keeping</strong>
                {`
                
Information provided by our customers is retained for a period of five years and protected using the latest technology.

`}
                <strong>Regular audits and reviews</strong>
                {`
                
Regular Audits are carried out by reputable audit firms in order to ensure that the policies and procedures are being complied with. The Triton Capital Markets Limited policies and procedures are regularly reviewed to ascertain that these reflect the current regulations and external environment.

Should you have any questions or queries regarding the contents of this policy please do not hesitate to contact us at compliance@markets-direct.com

`}
              </Text>
            </ResourcesSideBar>
          </div>
        </Content>
      </Wrapper>
    </WebsiteDefaultPage>
  );
};

export default PageContainer;

export const query = graphql`
  query {
    imageToWebP: allFile(filter: { relativeDirectory: { eq: "pages/resources" }, extension: { nin: ["svg", "gif"] } }) {
      edges {
        node {
          ...ImageToWebP
        }
      }
    }
    otherImage: allFile(filter: { relativeDirectory: { eq: "pages/resources" }, extension: { in: ["svg", "gif"] } }) {
      edges {
        node {
          ...OtherImage
        }
      }
    }
  }
`;
